export default __webpack_public_path__ + "icon_company_faste_ture.svg";